import {useEffect} from 'react'
import {MaDinhDanhEditModalFormWrapper} from './maDinhDanhEditModalFormWrapper'
import {MaDinhDanhEditModalHeader} from './maDinhDanhEditModalHeader'

const MaDinhDanhEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <MaDinhDanhEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body'>
              <MaDinhDanhEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {MaDinhDanhEditModal}
